import appPaths from '../../config/appPaths'
import publicPageSeo from '../../config/publicPageSeo'

export const PATH = appPaths.PATH
export const makePath = appPaths.makePath
export const makeGiftPath = appPaths.makeGiftPath
export const makeGiftStepsPath = appPaths.makeGiftStepsPath
export const makeLoginPath = appPaths.makeLoginPath
export const makeMemberApplicationPath = appPaths.makeMemberApplicationPath
export const makeMemberApplicationApplyPath =
  appPaths.makeMemberApplicationApplyPath
export const makeMemberPortalPath = appPaths.makeMemberPortalPath
export const makeMembershipsPath = appPaths.makeMembershipsPath
export const makeMembershipIdPath = appPaths.makeMembershipIdPath
export const makeMobileAppPath = appPaths.makeMobileAppPath
export const makeProgramsPortalPath = appPaths.makeProgramsPortalPath
export const makeProgramsApplicationPath = appPaths.makeProgramsApplicationPath
export const makeMarketingSitePath = appPaths.makeMarketingSitePath

export const isProduction = () => process.env.NODE_ENV === 'production'
export const usingTestApi = () => process.env.REACT_APP_USE_TEST_API === true

export const FEATURES = {
  CUSTOM_LOGIN: 'customLogin',
  MIXPANEL: 'mixpanel',
  REFERRAL_PROGRAM: 'referralProgram',
  TRIAL_MEMBERSHIPS: 'trialMemberships',
  UXCAM: 'uxcam',
}

export const FEATURED_FLAGS_LIST = [
  {
    name: FEATURES.CUSTOM_LOGIN,
    isActive: process.env.REACT_APP_SET_CUSTOM_LOGIN_ACTIVE === true,
  },
  {
    name: FEATURES.MIXPANEL,
    isActive: process.env.REACT_APP_SET_MIXPANEL_ENABLED === true,
  },
  {
    name: FEATURES.TRIAL_MEMBERSHIPS,
    isActive: process.env.REACT_APP_SET_TRIAL_MEMBERSHIPS_ACTIVE === true,
  },
  {
    name: FEATURES.REFERRAL_PROGRAM,
    isActive: process.env.REACT_APP_SET_REFERRAL_PROGRAM_ACTIVE === true,
  },
  {
    name: FEATURES.UXCAM,
    isActive: process.env.REACT_APP_SET_UXCAM_ENABLED === true,
  },
]

export const ADDRESS_FORM_VALIDATOR = {
  presence: { allowEmpty: false },
  validateNotEmail: true,
}

export const AUTOCOMPLETE_ADDRESS_FORM_VALIDATOR = {
  presence: { allowEmpty: false },
  validateStreetAddress: true,
}

export const TERMS_AGREEMENT_VALIDATOR = {
  presence: {
    message: 'must be accepted to continue',
  },
  inclusion: {
    within: [true],
    message: 'must be accepted to continue',
  },
}

export const APPLICATION = {
  MEMBER_PORTAL: 'members',
  PROGRAMS_PORTAL: 'programs',
  SEA_TOW: 'sea-tow',
}

export const APPLICATION_ROOT_URL = window.location.origin
export const makeApplicationPath = (...args) =>
  makePath(APPLICATION_ROOT_URL, ...args)

export const AUTHORIZED_APPLICATION = [
  APPLICATION.MEMBER_PORTAL,
  APPLICATION.PROGRAMS_PORTAL,
]

export const COST = {
  GOLD_UPGRADE: '$80',
  MEMBERSHIP_RENEWAL_CREDIT: '$25',
  REDUCED_CORPORATE_HOURLY_RATE: '$100',
  REFERRAL_CREDIT_MULTIPLIER: 25,
  REIMBURSEMENT_LIMIT: '$5000',
}

export const DIGITAL_WALLET_TYPE = { APPLE: 'Apple', GOOGLE: 'Google' }

// Note: if a new country is added, the COUNTRY_STATES map must also be updated to
// map the country to its associated list of states.
//
// Additionally, the following must also be udpated:
//    * the PHONE_REGION_CODE must also be udpated with the phone region code
//      for the added country.
//      See https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements
//    * the Cleave.js library that supports each coutnry must also be included in
//      src/entry/incdex.js
export const COUNTRY = {
  CANADA: 'Canada',
  MEXICO: 'Mexico',
  UNITED_STATES: 'United States',
}

export const COUNTRY_STATES = {
  [COUNTRY.CANADA]: [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Nova Scotia',
    'Northwest Territories',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon Territories',
  ],
  [COUNTRY.MEXICO]: [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Chihuahua',
    'Colima',
    'Campeche',
    'Coahuila',
    'Chiapas',
    'Federal District',
    'Durango',
    'Guerrero',
    'Guanajuato',
    'Hidalgo',
    'Jalisco',
    'Mexico State',
    'Michoacán',
    'Morelos',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'Sinaloa',
    'San Luis Potosí',
    'Sonora',
    'Tabasco',
    'Tlaxcala',
    'Tamaulipas',
    'Veracruz',
    'Yucatán',
    'Zacatecas',
  ],
  [COUNTRY.UNITED_STATES]: [
    'Armed Forces Americas',
    'Armed Forces Europe',
    'Alaska',
    'Alabama',
    'Armed Forces Pacific',
    'Arkansas',
    'American Samoa',
    'Arizona',
    'California',
    'Colorado',
    'Connecticut',
    'District of Columbia',
    'Delaware',
    'Florida',
    'Federated Micronesia',
    'Georgia',
    'Guam',
    'Hawaii',
    'Iowa',
    'Idaho',
    'Illinois',
    'Indiana',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Massachusetts',
    'Maryland',
    'Maine',
    'Marshall Islands',
    'Michigan',
    'Minnesota',
    'Missouri',
    'Northern Mariana Islands',
    'Mississippi',
    'Montana',
    'North Carolina',
    'North Dakota',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Palau',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'United States Minor Outlying Islands',
    'Utah',
    'Virginia',
    'US Virgin Islands',
    'Vermont',
    'Washington',
    'Wisconsin',
    'West Virginia',
    'Wyoming',
  ],
}

export const HOME_PORT_RESTRICTED_STATES = [
  'Florida',
  'Alaska',
  'Hawaii',
  'Puerto Rico',
  'Virgin Islands',
]

export const ADDRESS_SEARCH_DEBOUNCE_MS = 300
export const DEFAULT_MAP_ZOOM = 11
export const DEFAULT_SEARCH_RESULTS_PAGE_SIZE = 12
export const GIFT_DELIVERY_METHOD = 'Email'
export const GIFT_MESSAGE_LENGTH = 255

export const IMAGE_PATH = {
  ANCHOR_ICON: '/assets/images/imagery/purchase-flow/anchor-icon.png',
  CART_ICON: '/assets/images/icons/with-background/ST_YIcon_Cart.svg',
  DEFAULT_AOR_IMAGE: '/assets/images/captain-placeholder.png',
  DEFAULT_PARTNER_LOGO: '/assets/images/icons/transparent/ST_Icon_Account.svg',
  DROPDOWN_ICON: '/assets/images/icons/dropdown.svg',
  GIFT_CONFIRMATION: '/assets/images/imagery/gift-confirmation.png',
  MEMBER_APPLICATION_CONFIRMATION:
    '/assets/images/icons/with-background/ST_YIcon_Account-Holder.svg',
  MEMBERSHIP_KIT:
    '/assets/images/imagery/programs-portal/horizontal-membership-kits.jpg',
  MOBILE_APP_PROMO: '/assets/images/imagery/mobile-app-promo.jpg',
  REFERRALS_HEADER: '/assets/images/imagery/refer-with-text.jpg',
  SEA_CARE: '/assets/images/imagery/programs-portal/horizontal-seacare.jpg',
  SEATOW_LOGO: '/assets/images/logo.svg',
  SEATOW_MEMBER_CARD_LOGO: '/assets/images/sea-tow-membership-card.svg',
}

export const LOGIN_EXPERIENCE_TYPE = { CLASSIC: 'classic', NEW: 'new' }

export const MARKER_MAP_ZOOM = 13
export const MAXIMUM_DESCRIPTION_LENGTH = 1000 // characters
export const MAXIMUM_LOGO_SIZE = 500000 // bytes (500kb)
export const MEMBERSHIP_EXPIRATION_WARNING_DAYS = 45

// Additional PATH constants. Note that these must be defined *after* PATH is
// defined such that PATH has a value...
export const GIFT_APPLICATION_STEP_LINKS = [
  {
    stepName: 'Recipient Information',
    path: makeGiftStepsPath(PATH.RECIPIENT),
    stepIcon: '/assets/images/icons/with-background/ST_YIcon_Account.svg',
  },
  {
    stepName: 'Billing Information',
    path: makeGiftStepsPath(PATH.BILLING),
    stepIcon: '/assets/images/icons/transparent/ST_Icon_Dashboard.svg',
  },
  {
    stepName: 'Payment',
    path: makeGiftStepsPath(PATH.PAYMENT),
    stepIcon: '/assets/images/icons/with-background/ST_YIcon_Payment.svg',
  },
]

export const GIFT_BILLING_CONTACT_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'address',
  'city',
  'state',
  'postalCode',
  'country',
]

export const MEMBER_APPLICATION_STEP_LINKS = [
  {
    stepName: 'Contact Info',
    path: makeMemberApplicationApplyPath(PATH.CONTACT),
    stepIcon: '/assets/images/icons/with-background/ST_YIcon_Account.svg',
  },
  {
    stepName: 'Primary Boat Information',
    path: makeMemberApplicationApplyPath(PATH.BOATS),
    stepIcon: '/assets/images/icons/with-background/ST_YIcon_Prim-Boat.svg',
  },
  {
    stepName: 'Terms & Conditions',
    path: makeMemberApplicationApplyPath(PATH.TERMS_AND_CONDITIONS),
    stepIcon: '/assets/images/icons/with-background/ST_YIcon_Dashboard.svg',
  },
]

export const APPLICATION_STEP_NAME = {
  CONTACT_INFO: 'Contact Info',
  PRIMARY_BOAT_INFORMATION: 'Primary Boat Information',
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  RECIPIENT_INFORMATION: 'Recipient Information',
  BILLING_INFORMATION: 'Billing Information',
}

export const MEMBER_PORTAL_NAVIGATION_LINKS = [
  {
    icon: '/assets/images/icons/transparent/ST_Icon_Dashboard.svg',
    menuItemName: 'Membership Dashboard',
    path: makeMemberPortalPath(PATH.MEMBERSHIPS),
  },
  {
    icon: '/assets/images/icons/transparent/ST_Icon_Account.svg',
    menuItemName: 'Account Details & Preferences',
    path: makeMemberPortalPath(PATH.ACCOUNT),
  },
]

export const MEMBER_PORTAL_QUICKLINKS = [
  {
    linkName: 'Update Account Preferences',
    path: makeMemberPortalPath(PATH.ACCOUNT),
  },
  { linkName: 'Update Contacts', path: makeMemberPortalPath(PATH.ACCOUNT) },
  { linkName: 'Sea Tow Videos', path: 'https://www.seatow.com/videos' },
  { linkName: 'Sea Tow Blog', path: 'https://www.seatow.com/blog' },
  {
    linkName: 'Give a Gift Membership',
    path: makeMemberPortalPath(PATH.SEA_TOW_AS_A_GIFT),
  },
  { linkName: 'FAQ', path: 'https://www.seatow.com/faq' },
]

export const MEMBER_PORTAL_URL = makeApplicationPath(PATH.MEMBER_PORTAL)

export const PROGRAMS_NAVIGATION_LINKS = [
  {
    icon: '/assets/images/icons/transparent/ST_Icon_Dashboard.svg',
    menuItemName: 'Dashboard',
    path: makeProgramsPortalPath(PATH.PROGRAMS_DASHBOARD),
  },
  {
    icon: '/assets/images/icons/transparent/ST_Icon_Other.svg',
    menuItemName: 'Savings Club Offers',
    path: makeProgramsPortalPath(PATH.SAVINGS_CLUB_OFFERS),
  },
  {
    icon: '/assets/images/icons/transparent/ST_Icon_Account.svg',
    menuItemName: 'Account Details & Preferences',
    path: makeProgramsPortalPath(PATH.ACCOUNT),
  },
]

export const PROGRAMS_QUICKLINKS = [
  { linkName: 'Visit seatow.com', path: PATH.SEATOW },
  {
    linkName: 'Navigating the Program Portal',
    path: 'https://youtu.be/TUo8glJDgGw',
  },
  {
    linkName: 'Setting up your Account Profile',
    path: 'https://youtu.be/dUYo8dPR-nw',
  },
  { linkName: 'Updating your Password', path: 'https://youtu.be/SjwJyl2TmR8' },
]

export const SAVINGS_CLUB_INFO_LINKS = [
  {
    linkName: 'Creating a Savings Club Offer',
    path: 'https://youtu.be/GN6CYVbhpqY',
  },
  {
    linkName: 'Editing or Removing a Savings Club Offer',
    path: 'https://youtu.be/EafPZPKtgnw',
  },
]

export const PROGRAMS_PORTAL_URL = makeApplicationPath(PATH.PROGRAMS_PORTAL)

//////////////////////////////////////////////////////////////////////////////

export const PHONE_REGION_CODE = {
  [COUNTRY.CANADA]: 'CA',
  [COUNTRY.MEXICO]: 'MX',
  [COUNTRY.UNITED_STATES]: 'US',
}

export const QUERY_KEY = {
  ACCOUNT_ID: 'accountId',
  ACCOUNT_TYPE: 'accountType',
  APPLICATION: 'app',
  BACK: 'back',
  CATEGORY: 'category',
  COUNTRY: 'country',
  FORM_OPEN: 'formOpen',
  GCLID: 'gclid',
  MEMBERSHIP_EXPIRATION_DATE: 'membershipExpirationDate',
  MEMBERSHIP_NUMBER: 'membershipNumber',
  MSCLKID: 'msclkid',
  PAGE: 'page',
  REFERRAL: 'refId',
  SEARCH_TERM: 'q',
  SORT: 'sort',
  OFFER_ID: 'offerId',
  RETURN_TO: 'returnTo',
  STATUS: 'status',
  TEST_VARIANT: 'testvariant', // *TODO: Update query once decided by Marketing
  USERNAME: 'userName',
  ZIP: 'zip',
}

// Constants that use the QUERY_KEY in their definition...
export const SAVINGS_CLUB_SORT = {
  FEATURED: 'Featured',
  DISTANCE_FROM_ME: 'Distance from Me',
}

export const INITIAL_SAVINGS_CLUB_SEARCH = {
  [QUERY_KEY.CATEGORY]: 'All',
  [QUERY_KEY.SORT]: SAVINGS_CLUB_SORT.FEATURED,
}

export const OPTIONAL_SAVINGS_CLUB_SEARCH_KEYS = [QUERY_KEY.SEARCH_TERM]

/////////////////////////////////////////////////////////////////////////////
export const REACT_APP_API_REQUEST_TOKEN =
  process.env.REACT_APP_API_REQUEST_TOKEN
export const REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN
export const REACT_APP_GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY
export const REACT_APP_SEATOW_API = process.env.REACT_APP_SEATOW_API
export const REACT_APP_SEATOW_AUTH0_CLIENTID =
  process.env.REACT_APP_SEATOW_AUTH0_CLIENTID
export const REACT_APP_MIXPANEL_TOKEN =
  process.env.REACT_APP_MIXPANEL_TOKEN
export const REACT_APP_STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
export const REACT_APP_UXCAM_APP_KEY = process.env.REACT_APP_UXCAM_APP_KEY

export const SEATOW_AUTO_RENEW_CONTACT_EMAIL = 'autorenew@seatow.com'
export const SEATOW_MEMBERSHIP_AGREEMENT_URL =
  'www.seatow.com/membership-agreement/'
export const SEATOW_AUTO_RENEWAL_AGREEMENT_URL =
  'www.seatow.com/membership-agreement/#automatic-renewal-program-agreement'
export const SEATOW_PROGRAMS_CONTACT_EMAIL = 'workwithseatow@seatow.com'
export const SEATOW_PHONE = '800-4-SEATOW'
export const SEATOW_PHONE_DIGITS = '800-473-2869'
export const SEATOW_SFS_OPT_IN_NUMBER = '883383'
export const SEATOW_TRAILER_CARE_CONTACT_EMAIL = 'trailercare@seatow.com'
export const SEATOW_INFO_CONTACT_EMAIL = 'info@seatow.com'
export const SEATOW_MOBILE_APP_URL = 'https://onelink.to/seatow'
export const SEATOW_URL = 'www.seatow.com'

export const USER_RULES = {
  ARB_REQUIRED: 'ARB Required',
}

export const WP_API_URL = makePath(
  PATH.SEATOW,
  process.env.REACT_APP_SEA_TOW_WP_API,
)

///////////////////////////////////////////////////////////////////////////////

export const USER_METADATA = {
  ACCOUNT_RECORD_ID: 'https://seatow.com/account_record_id',
  INVALID_ACCOUNT_ID: 'INVALID',
  MEMBER_ACCOUNT_ID: 'https://seatow.com/member_account_id',
  PARTNER_ACCOUNT_ID: 'https://seatow.com/partner_account_id',
  TEMPORARY_PARTNER_ACCOUNT_ID:
    'https://seatow.com/temporary_partner_account_id',
  STRATEGY: 'https://seatow.com/strategy',
}

// Reads the account identifier from Auth0 user metadata.
export const getAccountIdentifier = (user) => {
  if (!user) return null
  return (
    user[USER_METADATA.ACCOUNT_RECORD_ID] ||
    user[USER_METADATA.MEMBER_ACCOUNT_ID] ||
    null
  )
}

// True when any membership has ever existed (active, lapsed, or otherwise).
// Either field can be set independently in Salesforce, so check both.
export const hasMembershipHistory = (memberships) =>
  !!memberships?.some((m) => m.membership_type__c || m.membership_status__c)

export const SITE_METADATA = publicPageSeo.SITE_METADATA
export const DEFAULT_SEO_DESCRIPTION = publicPageSeo.DEFAULT_SEO_DESCRIPTION
export const normalizeSeoDescription = publicPageSeo.normalizeSeoDescription

export const ORDER_CONFIRMATION_CONTENT = {
  NEW_MEMBER: {
    title: 'Welcome to Sea Tow',
    description: [
      'A membership confirmation email has been sent to you. Your membership will become active in 24 hours, and your permanent membership card will arrive by mail in 3 - 4 weeks.',
    ],
  },
  MEMBER_RENEWAL: {
    title: 'Thank you for renewing your Sea Tow membership',
    description: [
      'Please keep your current membership card; a new one will not be sent.',
      "If you haven't done so already, download your digital card for access to your membership details and Sea Tow's contact information, all in one spot, on your phone.",
    ],
  },
}

export const NEXT_STEPS_CONTENT = {
  NEW_MEMBER: {
    title: 'Create Your Online Account',
    description:
      'Create your username and password to access your account anytime, anywhere.',
    boats_info:
      'Add any missing boat information and/or add additional vessels',
    buttonText: 'Register & Log In',
  },
  MEMBER_RENEWAL: {
    title: 'Manage Your Online Account',
    description: 'Access your membership information anytime, anywhere.',
    boats_info:
      "Be sure you've added any missing boat information and/or add additional vessels",
    buttonText: 'Go to My Account',
  },
}

export const PAYMENT_STEP_TYPE = {
  NEW_MEMBERSHIP: 'New Membership',
  MEMBERSHIP_RENEWAL: 'Membership Renewal',
  MEMBERSHIP_UPGRADE: 'Membership Upgrade',
  SEA_TOW_GIFT: 'Sea Tow Gift',
  TRAILER_CARE_UPGRADE: 'Trailer Care Upgrade',
}
